export const experienceData = [
  {
    company: 'Pericles Capital',
    role: 'Co-Founder & Chief Investment Officer',
    roleVi: 'Đồng Sáng Lập & Giám Đốc Đầu Tư',
    location: 'Boston, MA',
    locationVi: 'Boston, MA',
    dates: 'June 2025 – Present',
    datesVi: 'Tháng 6/2025 – Hiện tại',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/j8GfrePYi2C56jir64ANpC/PCC_BGR2.png',
    description: [
      'Co-founded quantitative investment fund specializing in systematic trading strategies',
      'Lead research and development of algorithmic trading models across Long/Short equity, FX, and alternative assets',
      'Oversee portfolio construction, risk management, and quantitative strategy implementation',
    ],
    descriptionVi: [
      'Đồng sáng lập quỹ đầu tư định lượng chuyên về chiến lược giao dịch hệ thống',
      'Dẫn đầu nghiên cứu và phát triển mô hình giao dịch thuật toán trên cổ phiếu Long/Short, FX và tài sản thay thế',
      'Giám sát xây dựng danh mục đầu tư, quản lý rủi ro và triển khai chiến lược định lượng',
    ],
  },
  {
    company: 'State Street Investment Management',
    role: 'Incoming Spring Asset Management Analyst',
    roleVi: 'Chuyên Viên Phân Tích Quản Lý Tài Sản Mùa Xuân Sắp Tới',
    location: 'Boston, MA',
    locationVi: 'Boston, MA',
    dates: 'Jan 2026 – Apr 2026',
    datesVi: 'Tháng 1/2026 – Tháng 4/2026',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/agta6duKEorKsUKqpfgzbc/StateStreetIM.jpg',
    description: [
      'Incoming Spring 2026 Asset Management Analyst at State Street Investment Management',
      'Will support global product development and strategic partnerships across asset management products',
      'Expected to maintain key client relationships and coordinate with internal functions within SSIM',
    ],
    descriptionVi: [
      'Chuyên viên Phân tích Quản lý Tài sản Mùa Xuân 2026 sắp tới tại State Street Investment Management',
      'Sẽ hỗ trợ phát triển sản phẩm toàn cầu và quan hệ đối tác chiến lược trên các sản phẩm quản lý tài sản',
      'Dự kiến duy trì mối quan hệ khách hàng chính và phối hợp với các chức năng nội bộ trong SSIM',
    ],
  },
  {
    company: 'OCB',
    role: 'FX Sales & Trading Summer Analyst',
    roleVi: 'Chuyên Viên Phân Tích Bán Hàng & Giao Dịch FX Mùa Hè',
    location: 'Ho Chi Minh City, VN',
    locationVi: 'Thành phố Hồ Chí Minh, VN',
    dates: 'Jul 2025 – Aug 2025',
    datesVi: 'Tháng 7/2025 – Tháng 8/2025',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bgXvfaxuk8kt8mhmEEFRfu/OCB_logo.webp',
    description: [
      'Produced 10+ weekly interbank FX rate reports and G7 currency market analyses to support trading decisions',
      'Extracted and synthesized macroeconomic data through Bloomberg Terminal to deliver comprehensive FX trend reports',
      'Structured VND ₫1.25T ($49M) in client hedging solutions using currency forwards and innovative loan structures',
    ],
    descriptionVi: [
      'Lập 10+ báo cáo tỷ giá liên ngân hàng hàng tuần và phân tích thị trường tiền tệ G7 để hỗ trợ quyết định giao dịch',
      'Trích xuất và tổng hợp dữ liệu kinh tế vĩ mô thông qua Bloomberg Terminal để cung cấp báo cáo xu hướng FX toàn diện',
      'Cấu trúc 1,25 nghìn tỷ VND (49 triệu USD) giải pháp phòng ngừa rủi ro cho khách hàng sử dụng hợp đồng kỳ hạn tiền tệ và cấu trúc khoản vay sáng tạo',
    ],
  },
  {
    company: 'HFIC',
    role: 'Public Investment & Valuation Intern',
    roleVi: 'Thực Tập Sinh Đầu Tư Công & Định Giá',
    location: 'Ho Chi Minh City, VN',
    locationVi: 'Thành phố Hồ Chí Minh, VN',
    dates: 'Apr 2025 – June 2025',
    datesVi: 'Tháng 4/2025 – Tháng 6/2025',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bEZT63G8jccsjSrsA8C1Ef/HFIC_logo.png',
    description: [
      "Analyzed (HOSE: CII), one of Vietnam's largest state-owned joint venture construction companies, to assess potential corporate structure fraud",
      'Analyzed pre-IPO (OCT: THA), delivered the report to the investment team for potential divestment',
      'Structured VND ₫400B in loan packages for three public institutions through direct collaboration with their finance teams',
    ],
    descriptionVi: [
      'Phân tích (HOSE: CII), một trong những công ty xây dựng liên doanh nhà nước lớn nhất Việt Nam, để đánh giá gian lận cấu trúc doanh nghiệp tiềm ẩn',
      'Phân tích trước IPO (OCT: THA), trình báo cáo cho đội đầu tư để thoái vốn tiềm năng',
      'Cấu trúc 400 tỷ đồng trong các gói vay cho ba tổ chức công thông qua hợp tác trực tiếp với các đội tài chính của họ',
    ],
  },
  {
    company: 'Cavalina Property Group',
    role: 'Spring Real Estate Private Equity Intern',
    roleVi: 'Thực Tập Sinh Vốn Cổ Phần Tư Nhân Bất Động Sản Mùa Xuân',
    location: 'Philadelphia, PA',
    locationVi: 'Philadelphia, PA',
    dates: 'Feb 2025 – Apr 2025',
    datesVi: 'Tháng 2/2025 – Tháng 4/2025',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kPFEsGkCfPDiDeDkuRGQqE/Cavalina_property.jpg',
    description: [
      'Sourced and underwrote 3+ distressed and value-add residential and commercial deals across PA and NY market',
      'Secured wholesale contract 22.5% below market for a University Park SFR using creative financing strategies',
      'Built comps, pro forma/T-12 extend models for $400M USD mixed-use project in NJ; leveraged PropStream, Bright MLS',
    ],
    descriptionVi: [
      'Tìm nguồn và bảo lãnh 3+ thương vụ nhà ở và thương mại khó khăn và gia tăng giá trị trên thị trường PA và NY',
      'Bảo đảm hợp đồng bán buôn thấp hơn 22,5% so với thị trường cho một SFR University Park bằng cách sử dụng chiến lược tài chính sáng tạo',
      'Xây dựng các mô hình so sánh, dự kiến/T-12 mở rộng cho dự án đa dụng 400 triệu USD tại NJ; tận dụng PropStream, Bright MLS',
    ],
  },
  {
    company: 'Westlake Securities',
    role: 'Fall Equity Research Analyst',
    roleVi: 'Chuyên Viên Phân Tích Nghiên Cứu Cổ Phiếu Mùa Thu',
    location: 'Austin, TX',
    locationVi: 'Austin, TX',
    dates: 'Sep 2024 – Dec 2024',
    datesVi: 'Tháng 9/2024 – Tháng 12/2024',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cScWV5Tt9MjHewnunghdSv/Westlake_logo.png',
    description: [
      'Researched Walmart (NYSE: WMT) and Loan Depot (NYSE: LDI), delivering two research reports',
      'Developed comparable tables to assess competitiveness and fair valuation against peer firms',
      'Forecasted macroeconomic impacts on WMT and LDI, including U.S.-China trade tensions and Fed rate cuts',
    ],
    descriptionVi: [
      'Nghiên cứu Walmart (NYSE: WMT) và Loan Depot (NYSE: LDI), cung cấp hai báo cáo nghiên cứu',
      'Phát triển bảng so sánh để đánh giá khả năng cạnh tranh và định giá hợp lý so với các công ty cùng ngành',
      'Dự báo tác động kinh tế vĩ mô đến WMT và LDI, bao gồm căng thẳng thương mại Mỹ-Trung và cắt giảm lãi suất của Fed',
    ],
  },
  {
    company: 'Springer Capital',
    role: 'Fall Real Estate Private Equity Intern',
    roleVi: 'Thực Tập Sinh Vốn Cổ Phần Tư Nhân Bất Động Sản Mùa Thu',
    location: 'Chicago, IL',
    locationVi: 'Chicago, IL',
    dates: 'Sep 2024 – Dec 2024',
    datesVi: 'Tháng 9/2024 – Tháng 12/2024',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iMunHTftH66JNhCZahKiGx/Springer_Capital.png',
    description: [
      'Facilitated 2+ real estate acquisitions by analyzing market trends and property cash flows',
      'Collaborated with 10+ team members to streamline due diligence, cutting due diligence time by 20%',
      'Developed 2+ excel models and comparable tables to optimize investment decisions, enhancing competitiveness and ROI',
    ],
    descriptionVi: [
      'Tạo điều kiện cho 2+ vụ mua bán bất động sản bằng cách phân tích xu hướng thị trường và dòng tiền từ bất động sản',
      'Hợp tác với 10+ thành viên nhóm để hợp lý hóa thẩm định, cắt giảm 20% thời gian thẩm định',
      'Phát triển 2+ mô hình excel và bảng so sánh để tối ưu hóa quyết định đầu tư, nâng cao khả năng cạnh tranh và ROI',
    ],
  },
  {
    company: 'HP Inc.',
    role: 'Corporate Venture Capital & Business Analytics Extern',
    roleVi:
      'Thực Tập Sinh Vốn Đầu Tư Mạo Hiểm Doanh Nghiệp & Phân Tích Kinh Doanh',
    location: 'Palo Alto, CA',
    locationVi: 'Palo Alto, CA',
    dates: 'Sep 2024 – Oct 2024',
    datesVi: 'Tháng 9/2024 – Tháng 10/2024',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5vGKGhT7mEU5Tjp46WbCNd/HP_Logo.png',
    description: [
      'Analyzed Series A & B AI startups for potential investment opportunities',
      'Conducted macro industry research to identify emerging technology trends',
      'Supported business operations team with process improvements and data analysis',
    ],
    descriptionVi: [
      'Phân tích các startup AI Series A & B để tìm cơ hội đầu tư tiềm năng',
      'Thực hiện nghiên cứu ngành vĩ mô để xác định xu hướng công nghệ mới nổi',
      'Hỗ trợ đội hoạt động kinh doanh với cải tiến quy trình và phân tích dữ liệu',
    ],
  },
  {
    company: 'VinaCapital',
    role: 'Summer Equity Research & Investment Intern',
    roleVi: 'Thực Tập Sinh Nghiên Cứu Cổ Phiếu & Đầu Tư Mùa Hè',
    location: 'Ho Chi Minh City, VN',
    locationVi: 'Thành phố Hồ Chí Minh, VN',
    dates: 'May 2024 – Aug 2024',
    datesVi: 'Tháng 5/2024 – Tháng 8/2024',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/69Gfi9nZCzPf22b9ez85ro/VinaCapital_Logo.png',
    description: [
      'Analyzed 5 Vietnamese industrial companies and forecasted macroeconomic impact of Chinese steel trends',
      'Proposed a 10%/58%/26.5%/5.5% asset allocation strategy for optimized returns and minimized risks',
      "Built a model projecting USD $200M+ inflows into Vietnam's capital market driven by middle-class growth",
    ],
    descriptionVi: [
      'Phân tích 5 công ty công nghiệp Việt Nam và dự báo tác động kinh tế vĩ mô của xu hướng thép Trung Quốc',
      'Đề xuất chiến lược phân bổ tài sản 10%/58%/26,5%/5,5% để tối ưu hóa lợi nhuận và giảm thiểu rủi ro',
      'Xây dựng mô hình dự báo dòng vốn 200 triệu USD+ vào thị trường vốn Việt Nam do tăng trưởng tầng lớp trung lưu',
    ],
  },
  {
    company: 'Airevo',
    role: 'Co-Founder & CEO',
    roleVi: 'Đồng Sáng Lập & CEO',
    location: 'Boston, MA',
    locationVi: 'Boston, MA',
    dates: 'Oct 2024 – Sep 2025',
    datesVi: 'Tháng 10/2024 – Tháng 9/2025',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5r3t4zwbdRgKFGDrNNF34C/Copy_of_Airevo_-_3-removebg-preview.png',
    description: [
      'Led a prop-tech real estate AI startup focused on revolutionizing property management and investment',
      'Developed innovative AI solutions for real estate market analysis and property valuation',
      'Built strategic partnerships with real estate professionals and tech investors to scale the platform',
    ],
    descriptionVi: [
      'Lãnh đạo một startup AI bất động sản prop-tech tập trung vào cách mạng hóa quản lý và đầu tư bất động sản',
      'Phát triển giải pháp AI sáng tạo cho phân tích thị trường bất động sản và định giá bất động sản',
      'Xây dựng quan hệ đối tác chiến lược với các chuyên gia bất động sản và nhà đầu tư công nghệ để mở rộng nền tảng',
    ],
    website: 'https://airevoapp.com',
  },
]

export const projectsData = [
  {
    title: 'AidWorks Foundation',
    titleVi: 'Quỹ AidWorks',
    role: 'Founder & CEO',
    roleVi: 'Người Sáng Lập & CEO',
    description:
      'Raised $13,500+ donations annually to serve 3500+ individuals through 120+ registered volunteers and 14+ institution partners.',
    descriptionVi:
      'Gây quỹ hơn $13,500 hàng năm để phục vụ hơn 3500 cá nhân thông qua hơn 120 tình nguyện viên đăng ký và 14+ đối tác tổ chức.',
    image:
      'https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80',
    link: '#',
  },
  {
    title: 'Northeastern Investment Banking Group',
    titleVi: 'Nhóm Ngân Hàng Đầu Tư Northeastern',
    role: 'Vice President',
    roleVi: 'Phó Chủ Tịch',
    description:
      'Served across all key functions, grew the club to 30+ active members and educated 40+ students.',
    descriptionVi:
      'Phục vụ trong tất cả các chức năng chính, phát triển câu lạc bộ lên hơn 30 thành viên tích cực và đào tạo hơn 40 sinh viên.',
    image:
      'https://images.unsplash.com/photo-1591696205602-2f950c417cb9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
    link: '#',
  },
  {
    title: 'Vu A Dinh Scholarship Fund',
    titleVi: 'Quỹ Học Bổng Vừ A Dính',
    role: 'Deputy Chief External Relations Officer',
    roleVi: 'Phó Giám Đốc Đối Ngoại',
    description:
      'Handled USD$18M donations, maintained 120+ corporate partners, spearheaded 2 major events to support veterans.',
    descriptionVi:
      'Quản lý $18M tiền quyên góp, duy trì hơn 120 đối tác doanh nghiệp, dẫn đầu 2 sự kiện lớn để hỗ trợ cựu chiến binh.',
    image:
      'https://images.unsplash.com/photo-1577896851231-70ef18881754?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
    link: '#',
  },
  {
    title: 'Goldman Sachs 2025 Possibilities Summit',
    titleVi: 'Hội Nghị Possibilities 2025 của Goldman Sachs',
    role: 'Participant',
    roleVi: 'Người Tham Gia',
    description:
      'Selected for exclusive program providing insight into investment banking and financial markets.',
    descriptionVi:
      'Được chọn cho chương trình độc quyền cung cấp cái nhìn sâu sắc về ngân hàng đầu tư và thị trường tài chính.',
    image:
      'https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
    link: '#',
  },
]

export const leadershipData = {
  nonprofit: [
    {
      organization: 'AidWorks Foundation',
      organizationVi: 'Quỹ AidWorks',
      role: 'Founder & CEO',
      roleVi: 'Người Sáng Lập & CEO',
      description:
        'Raised $13,500+ donations annually to serve 3500+ individuals through 100+ registered volunteers and 14+ institution partners.',
      descriptionVi:
        'Gây quỹ hơn $13,500 hàng năm để phục vụ hơn 3500 cá nhân thông qua hơn 100 tình nguyện viên đăng ký và 14+ đối tác tổ chức.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/83Ws5PExbShxEko1K2171B/AidWorks_Logo.png',
    },
    {
      organization: 'Vu A Dinh Scholarship Fund',
      organizationVi: 'Quỹ Học Bổng Vừ A Dính',
      role: 'Deputy Chief External Relations Officer',
      roleVi: 'Phó Giám Đốc Đối Ngoại',
      description:
        'Handled 471B VND ($18M) donations, maintained 120+ corporate partners, spearheaded 2 major events to support veterans.',
      descriptionVi:
        'Quản lý 471 tỷ VND (18 triệu USD) tiền quyên góp, duy trì hơn 120 đối tác doanh nghiệp, dẫn đầu 2 sự kiện lớn để hỗ trợ cựu chiến binh.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/5i1QqdVxMMZHJd3vprdEDY/Vu_A_Dinh_Logo.jpg',
    },
  ],
  university: [
    {
      organization: 'Northeastern Investment Banking Group',
      organizationVi: 'Nhóm Ngân Hàng Đầu Tư Northeastern',
      role: 'Interim President',
      roleVi: 'Chủ Tịch Lâm Thời',
      description:
        'Served across all key functions, grew the club to 30+ active members and educated 40+ students.',
      descriptionVi:
        'Phục vụ trong tất cả các chức năng chính, phát triển câu lạc bộ lên hơn 30 thành viên tích cực và đào tạo hơn 40 sinh viên.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/kGUSAPgUWXiedLVNceKZ5W/NIBG_Logo.png',
    },
    {
      organization: 'Goldman Sachs',
      organizationVi: 'Goldman Sachs',
      role: 'Possibilities Summit Participant',
      roleVi: 'Người Tham Gia Hội Nghị Possibilities',
      description:
        'Selected for exclusive program providing insight into investment banking and financial markets.',
      descriptionVi:
        'Được chọn cho chương trình độc quyền cung cấp cái nhìn sâu sắc về ngân hàng đầu tư và thị trường tài chính.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/2pvq5grFQhQzVVpAS7yvGH/Goldman_Sachs_logo.png',
    },
    {
      organization: 'DECA',
      organizationVi: 'DECA',
      role: 'International Finalist',
      roleVi: 'Người Vào Chung Kết Quốc Tế',
      description:
        'DECA International Finalist (x1), DECA State Champions (x2), DECA Regional Champions (x2).',
      descriptionVi:
        'Người vào chung kết DECA Quốc tế (x1), Vô địch DECA Tiểu bang (x2), Vô địch DECA Khu vực (x2).',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/mEymbFb5Ffw8dSyzGKVyU1/DECA_logo.png',
    },
    {
      organization: 'PeakSpan Capital',
      organizationVi: 'PeakSpan Capital',
      role: 'Growth Equity Immersion Participant',
      roleVi: 'Người Tham Gia Chương Trình Đắm Chìm Vốn Cổ Phần Tăng Trưởng',
      description:
        'Selected for PeakSpan Capital Growth Equity Immersion program to gain hands-on experience in growth equity investing.',
      descriptionVi:
        'Được chọn cho chương trình Đắm Chìm Vốn Cổ Phần Tăng Trưởng của PeakSpan Capital để có kinh nghiệm thực tế trong đầu tư vốn cổ phần tăng trưởng.',
      image:
        'https://uploadthingy.s3.us-west-1.amazonaws.com/kPnTF9B887piK4FUCaGbXR/PeakSpan_Logo.png',
    },
  ],
}

export const companyLogos = [
  {
    name: 'Pericles Capital',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/j8GfrePYi2C56jir64ANpC/PCC_BGR2.png',
    role: 'Co-Founder & Chief Investment Officer',
    roleVi: 'Đồng Sáng Lập & Giám Đốc Đầu Tư',
    year: '2025-Present',
    yearVi: '2025-Hiện tại',
  },
  {
    name: 'State Street Investment Management',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/agta6duKEorKsUKqpfgzbc/StateStreetIM.jpg',
    role: 'Incoming Spring Asset Management Analyst',
    roleVi: 'Chuyên Viên Phân Tích Quản Lý Tài Sản Mùa Xuân Sắp Tới',
    year: '2025',
  },
  {
    name: 'OCB',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bgXvfaxuk8kt8mhmEEFRfu/OCB_logo.webp',
    role: 'FX Sales & Trading Summer Analyst',
    roleVi: 'Chuyên Viên Phân Tích Bán Hàng & Giao Dịch FX Mùa Hè',
    year: '2025',
  },
  {
    name: 'HFIC',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bEZT63G8jccsjSrsA8C1Ef/HFIC_logo.png',
    role: 'Public Investment & Valuation Intern',
    roleVi: 'Thực Tập Sinh Đầu Tư Công & Định Giá',
    year: '2025',
  },
  {
    name: 'Cavalina Property Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kPFEsGkCfPDiDeDkuRGQqE/Cavalina_property.jpg',
    role: 'Spring Real Estate Private Equity Intern',
    roleVi: 'Thực Tập Sinh Vốn Cổ Phần Tư Nhân Bất Động Sản Mùa Xuân',
    year: '2025',
  },
  {
    name: 'Westlake Securities',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cScWV5Tt9MjHewnunghdSv/Westlake_logo.png',
    role: 'Fall Equity Research Analyst',
    roleVi: 'Chuyên Viên Phân Tích Nghiên Cứu Cổ Phiếu Mùa Thu',
    year: '2024',
  },
  {
    name: 'HP Inc.',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5vGKGhT7mEU5Tjp46WbCNd/HP_Logo.png',
    role: 'Corporate Venture Capital & Business Analytics Extern',
    roleVi:
      'Thực Tập Sinh Vốn Đầu Tư Mạo Hiểm Doanh Nghiệp & Phân Tích Kinh Doanh',
    year: '2024',
  },
  {
    name: 'VinaCapital',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/69Gfi9nZCzPf22b9ez85ro/VinaCapital_Logo.png',
    role: 'Summer Equity Research & Investment Intern',
    roleVi: 'Thực Tập Sinh Nghiên Cứu Cổ Phiếu & Đầu Tư Mùa Hè',
    year: '2024',
  },
  {
    name: 'Airevo',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5r3t4zwbdRgKFGDrNNF34C/Copy_of_Airevo_-_3-removebg-preview.png',
    role: 'Co-Founder & CEO',
    roleVi: 'Đồng Sáng Lập & CEO',
    year: '2024-2025',
  },
]

export const educationData = {
  school: 'Northeastern University',
  location: 'Boston, MA',
  degree: 'Bachelor of Science in Business Admin: Finance',
  degreeVi: 'Cử nhân Khoa học Quản trị Kinh doanh: Tài chính',
  minor: 'Data Science',
  minorVi: 'Khoa học Dữ liệu',
  gpa: '3.83/4.0',
  dates: 'Sep 2024 – May 2028',
  datesVi: 'Tháng 9/2024 – Tháng 5/2028',
  honors: [
    "Dean's List",
    'DECA International Finalist',
    'DECA State Champions (x2)',
    'DECA Regional Champions (x2)',
    'Highest Honor Roll (x4)',
    'Seal of Biliteracy with Distinction',
    "Northeastern Dean's Scholarship",
    'F1RST Scholars',
  ],
  honorsVi: [
    'Danh sách Hiệu trưởng',
    'Người vào chung kết DECA Quốc tế',
    'Vô địch DECA Tiểu bang (x2)',
    'Vô địch DECA Khu vực (x2)',
    'Bảng Danh dự Cao nhất (x4)',
    'Con dấu Song ngữ với Sự xuất sắc',
    'Học bổng Hiệu trưởng Northeastern',
    'Học giả F1RST',
  ],
  courses: [
    'Financial Management',
    'Accounting 101 & 102 H',
    'Economics 101 & 102',
    'AP Statistics',
    'AP Calculus',
  ],
  coursesVi: [
    'Quản lý Tài chính',
    'Kế toán 101 & 102 H',
    'Kinh tế học 101 & 102',
    'Thống kê AP',
    'Giải tích AP',
  ],
  certifications: [
    'CFI 3 Financial Statements',
    'Financial Analysis & Fundamentals',
    'Pitch Book',
    'Bloomberg Market Concept',
  ],
  certificationsVi: [
    'CFI 3 Báo cáo Tài chính',
    'Phân tích Tài chính & Cơ bản',
    'Sách Giới thiệu',
    'Khái niệm Thị trường Bloomberg',
  ],
  programs: [
    'Goldman Sachs 2025 Possibilities Summit',
    'PeakSpan Capital Growth Equity Immersion',
  ],
  programsVi: [
    'Hội nghị Possibilities 2025 của Goldman Sachs',
    'Đắm chìm Vốn Cổ phần Tăng trưởng PeakSpan Capital',
  ],
}

export const skillsData = {
  languages: ['English', 'Vietnamese'],
  languagesVi: ['Tiếng Anh', 'Tiếng Việt'],
  languagesTranslation: {
    English: {
      vietnamese: 'Tiếng Anh',
      proficiency: '100%',
    },
    Vietnamese: {
      english: 'Vietnamese',
      proficiency: '95%',
    },
  },
  technical: [
    'MS Excel',
    'MS PowerPoint',
    'MS Word',
    'Keynote',
    'Bloomberg Terminal',
    'HTML',
    'CSS',
    'Python',
    'Racket',
    'Javascript',
  ],
  interests: [
    'Backpacking',
    'Travel',
    'Food Exploration',
    'Watch Enthusiast',
    'Piano',
    'Netflix Shows',
  ],
  interestsVi: [
    'Du lịch Ba lô',
    'Du lịch',
    'Khám phá Ẩm thực',
    'Đam mê Đồng hồ',
    'Piano',
    'Chương trình Netflix',
  ],
}

export const contactData = {
  email: 'officialtrungnguyen@gmail.com',
  phone: '(774) 670-6733',
  linkedin: 'linkedin.com/in/realtrungnguyen',
}

export const certificationsData = [
  {
    name: 'Bloomberg Market Concepts',
    nameVi: 'Khái niệm Thị trường Bloomberg',
    organization: 'Bloomberg',
    organizationVi: 'Bloomberg',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/amt8QY4uUXq4pXQJ5dQLRq/Bloomberg_logo.png',
    link: 'https://portal.bloombergforeducation.com/certificates/gY1XpAntfcMa1Jng2eX3q6dG',
    description:
      'Comprehensive e-learning course on financial markets and Bloomberg Terminal functionality',
    descriptionVi:
      'Khóa học e-learning toàn diện về thị trường tài chính và chức năng của Bloomberg Terminal',
  },
  {
    name: 'Financial Analysis & Fundamentals',
    nameVi: 'Phân tích Tài chính & Cơ bản',
    organization: 'Corporate Finance Institute',
    organizationVi: 'Viện Tài chính Doanh nghiệp',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4C4DwVGhvTaptFEeWmbxbp/CPI_logo.webp',
    link: 'https://credentials.corporatefinanceinstitute.com/8a55348f-f530-4e68-af28-fc0d44bc064a#acc.QGS28ywt',
    description:
      'Advanced financial analysis and modeling skills certification',
    descriptionVi:
      'Chứng chỉ kỹ năng phân tích và mô hình hóa tài chính nâng cao',
  },
  {
    name: 'Investment Banking Virtual Experience',
    nameVi: 'Kinh nghiệm Ảo về Ngân hàng Đầu tư',
    organization: 'JP Morgan Chase',
    organizationVi: 'JP Morgan Chase',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/h2uhRDbcpVnPgFYDwgiMPa/JPM_Logo.png',
    link: 'https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/JPMorgan%20Chase/YD2kY95RQxQtXxFTS_JPMorgan%20Chase_64F8QYXdHiA42ANhe_1710985177270_completion_certificate.pdf',
    description:
      "Practical investment banking skills through JP Morgan's virtual work experience program",
    descriptionVi:
      'Kỹ năng ngân hàng đầu tư thực tế thông qua chương trình kinh nghiệm làm việc ảo của JP Morgan',
  },
  {
    name: 'Strategy Consulting Virtual Experience',
    nameVi: 'Kinh nghiệm Ảo về Tư vấn Chiến lược',
    organization: 'Boston Consulting Group',
    organizationVi: 'Boston Consulting Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eH48qhT7ZzGm3fr611QWHe/BCG_logo.png',
    link: 'https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/BCG%20/4Rfzeut8gXmNwfxXv_BCG%20_64F8QYXdHiA42ANhe_1710727242314_completion_certificate.pdf',
    description:
      'Strategic consulting methodology and problem-solving certification',
    descriptionVi:
      'Chứng chỉ phương pháp tư vấn chiến lược và giải quyết vấn đề',
  },
  {
    name: 'Investment Banking Virtual Experience',
    nameVi: 'Kinh nghiệm Ảo về Ngân hàng Đầu tư',
    organization: 'Goldman Sachs',
    organizationVi: 'Goldman Sachs',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/m42bp4PAAecz2WmNFXpK9r/GS_logo.png',
    link: 'https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Goldman%20Sachs/NPdeQ43o8P9HJmJzg_Goldman%20Sachs_64F8QYXdHiA42ANhe_1711039161413_completion_certificate.pdf',
    description:
      "Comprehensive investment banking skills through Goldman Sachs' virtual program",
    descriptionVi:
      'Kỹ năng ngân hàng đầu tư toàn diện thông qua chương trình ảo của Goldman Sachs',
  },
  {
    name: 'First Aid Certification',
    nameVi: 'Chứng chỉ Sơ cứu',
    organization: 'American Red Cross',
    organizationVi: 'Hội Chữ thập đỏ Hoa Kỳ',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fZquAM8crf7AVcBEGK71A9/Red_Cross_logo.png',
    link: 'https://www.redcross.org/take-a-class/qrcode?certnumber=00JK3FV',
    description:
      'Certified in first aid, emergency response, and life-saving techniques',
    descriptionVi:
      'Được chứng nhận về sơ cứu, ứng phó khẩn cấp và kỹ thuật cứu sinh',
  },
]

export const statsData = [
  {
    id: 'stats-section',
    title: 'My Achievements',
    titleVi: 'Thành tựu của tôi',
    stats: [
      {
        id: 'vuadinh-donations',
        label: 'Vu A Dinh: Donations Handled',
        labelVi: 'Vừ A Dính: Quản lý Quyên góp',
        value: 471,
        suffix: 'B VND',
        alternateValue: 17.8,
        alternateSuffix: 'M USD',
        hasCurrencyToggle: true,
        duration: 6,
      },
      {
        id: 'vuadinh-donors',
        label: 'Vu A Dinh: Corporate Donors',
        labelVi: 'Vừ A Dính: Nhà tài trợ Doanh nghiệp',
        value: 120,
        suffix: '+',
        duration: 5,
      },
      {
        id: 'total-people-impacted',
        label: 'Total People Impacted',
        labelVi: 'Tổng số Người Được Hỗ Trợ',
        value: 93500,
        suffix: '+',
        duration: 7,
      },
      {
        id: 'ocb-hedging',
        label: 'OCB: Client Hedging Solutions',
        labelVi: 'OCB: Giải pháp Phòng ngừa rủi ro Khách hàng',
        value: 1.25,
        suffix: 'T VND',
        alternateValue: 47.3,
        alternateSuffix: 'M USD',
        hasCurrencyToggle: true,
        duration: 6,
      },
      {
        id: 'hfic-loans',
        label: 'HFIC: Loan Packages',
        labelVi: 'HFIC: Gói vay',
        value: 400,
        suffix: 'B VND',
        alternateValue: 15.2,
        alternateSuffix: 'M USD',
        hasCurrencyToggle: true,
        duration: 5.5,
      },
      {
        id: 'cavalina-project',
        label: 'Cavalina: Mixed-Use Project Model',
        labelVi: 'Cavalina: Mô hình Dự án Đa dụng',
        value: 400,
        suffix: 'M USD',
        alternateValue: 10.56,
        alternateSuffix: 'T VND',
        hasCurrencyToggle: true,
        duration: 5.5,
      },
      {
        id: 'sps-fundraising',
        label: 'Class 2024: Fundraising',
        labelVi: 'Lớp 2024: Gây quỹ',
        value: 55,
        suffix: 'K USD',
        alternateValue: 1.45,
        alternateSuffix: 'B VND',
        hasCurrencyToggle: true,
        duration: 5,
      },
      {
        id: 'school-expansion',
        label: 'School Expansion Funding',
        labelVi: 'Tài trợ Mở rộng Trường học',
        value: 3,
        suffix: 'M USD',
        alternateValue: 79.2,
        alternateSuffix: 'B VND',
        hasCurrencyToggle: true,
        duration: 5.5,
      },
      {
        id: 'aidworks-fundraising',
        label: 'AidWorks: Annual Fundraising',
        labelVi: 'AidWorks: Gây quỹ Hàng năm',
        value: 13.5,
        suffix: 'K USD',
        alternateValue: 356.4,
        alternateSuffix: 'M VND',
        hasCurrencyToggle: true,
        duration: 5,
      },
      {
        id: 'aidworks-volunteers',
        label: 'AidWorks: Volunteers',
        labelVi: 'AidWorks: Tình nguyện viên',
        value: 100,
        suffix: '+',
        duration: 5,
      },
      {
        id: 'people-impacted',
        label: 'AidWorks: People Directly Impacted',
        labelVi: 'AidWorks: Người Được Hỗ Trợ Trực tiếp',
        value: 3500,
        suffix: '+',
        duration: 6,
      },
      {
        id: 'social-impressions',
        label: 'AidWorks: Social Media Impressions',
        labelVi: 'AidWorks: Lượt Tiếp cận Mạng xã hội',
        value: 100000,
        suffix: '+',
        duration: 7,
      },
      {
        id: 'nibg-members',
        label: 'NIBG: Club Members',
        labelVi: 'NIBG: Thành viên Câu lạc bộ',
        value: 30,
        suffix: '+',
        duration: 5,
      },
      {
        id: 'gpa',
        label: 'GPA',
        labelVi: 'GPA',
        value: 3.9,
        suffix: '/4.0',
        duration: 5,
      },
    ],
  },
]
